import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetAuthToken, SetUser, UnsetUser } from './user.action';

export interface UserModel {
  id: string;
  email: string;
  name: string | null;
  photo: string | null;
  phone: string | number | null;
  provider: string;
}
export interface AuthStateModel {
  user: UserModel | null;
  authToken: string | null;
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    user: null,
    authToken: null,
  },
})
@Injectable()
export class AuthState {
  @Selector()
  static user(state: AuthStateModel): any {
    return state.user;
  }

  @Selector()
  static authToken(state: AuthStateModel): string | null {
    return state.authToken;
  }

  constructor() {}

  @Action(SetUser)
  async setUser(ctx: StateContext<AuthStateModel>, action: SetUser) {
    const state = ctx.getState();

    ctx.setState({
      ...state,
      user: action.user,
    });
  }

  @Action(SetAuthToken)
  async setAuthToken(ctx: StateContext<AuthStateModel>, action: SetAuthToken) {
    const state = ctx.getState();

    ctx.setState({
      ...state,
      authToken: action.authToken,
    });
  }

  @Action(UnsetUser)
  async unsetUser(ctx: StateContext<AuthStateModel>, action: UnsetUser) {
    const state = ctx.getState();

    ctx.setState({
      ...state,
      authToken: null,
      user: null,
    });
  }
}
